(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["amris-motion"] && !Shopify.designMode) return;
  try {
    (() => {
  if (!('IntersectionObserver' in window)) return;
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const hidden = new Set();
  const pending = new Set();
  const selector = 'product-card, collection-card, .amris-category-tile';
  let frame = 0;
  let mutations;
  let main;
  function reveal(element) {
    element.classList.remove('amris-reveal-pending');
    hidden.delete(element);
    observer.unobserve(element);
  }
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      const element = entry.target;
      if (preference.matches || element.contains(document.activeElement)) {
        reveal(element);
        continue;
      }
      if (entry.isIntersecting) {
        reveal(element);
      } else if (entry.boundingClientRect.top >= (entry.rootBounds?.bottom ?? innerHeight)) {
        element.classList.add('amris-scroll-card', 'amris-reveal-pending');
        hidden.add(element);
      } else if (!hidden.has(element)) {
        observer.unobserve(element);
      }
    }
  }, { threshold: 0 });
  function watch(element) {
    if (seen.has(element)) return;
    seen.add(element);
    observer.observe(element);
  }
  function scan(root) {
    if (preference.matches || !root.isConnected) return;
    if (root.matches?.(selector)) watch(root);
    for (const element of root.querySelectorAll(selector)) watch(element);
  }
  function queue(root) {
    if (root.nodeType !== 1 || preference.matches) return;
    pending.add(root);
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      const roots = [...pending];
      pending.clear();
      for (const item of roots) {
        if (!roots.some(parent => parent !== item && parent.contains(item))) scan(item);
      }
    });
  }
  function suspend() {
    mutations?.disconnect();
    observer.disconnect();
    if (frame) cancelAnimationFrame(frame);
    frame = 0;
    pending.clear();
    for (const element of hidden) element.classList.remove('amris-reveal-pending');
    hidden.clear();
  }
  function start() {
    main = document.getElementById('MainContent');
    if (!main || preference.matches) return;
    scan(main);
    mutations ??= new MutationObserver(records => {
      for (const record of records) {
        for (const node of record.addedNodes) queue(node);
        for (const node of record.removedNodes) {
          if (node.nodeType !== 1) continue;
          for (const element of hidden) {
            if (node === element || node.contains(element)) reveal(element);
          }
        }
      }
    });
    mutations.observe(main, { childList: true, subtree: true });
  }
  preference.addEventListener('change', () => preference.matches ? suspend() : start());
  document.addEventListener('focusin', event => {
    const card = event.target.closest?.('.amris-reveal-pending');
    if (card) reveal(card);
  });
  document.addEventListener('shopify:section:load', event => queue(event.target));
  window.addEventListener('pagehide', suspend);
  window.addEventListener('pageshow', event => { if (event.persisted) start(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
